import type { RecordView } from '@kit/sync/types/record-view';
import type { Priority } from '@/entities/shared/priority/priority';
import type { ShoppingItem } from '../schemas/shopping-item';

type ShoppingTotals = {
  readonly pendingCount: number;
  /** Sum of the estimates of what is pending. */
  readonly estimated: number;
  /** Pending entries without an estimate (the total is a lower bound while > 0). */
  readonly unestimated: number;
  readonly byPriority: Readonly<Record<Priority, number>>;
  /** What was actually paid for what was bought. */
  readonly spent: number;
};

export function shoppingTotals(list: readonly RecordView<ShoppingItem>[]): ShoppingTotals {
  let pendingCount = 0;
  let estimated = 0;
  let unestimated = 0;
  let spent = 0;
  const byPriority = { high: 0, medium: 0, low: 0 };
  for (const { data } of list) {
    if (data.status === 'pending') {
      pendingCount++;
      if (data.estimated_price_cents == null) unestimated++;
      estimated += data.estimated_price_cents ?? 0;
      byPriority[data.priority] += data.estimated_price_cents ?? 0;
    } else if (data.status === 'bought') {
      spent += data.price_cents ?? data.estimated_price_cents ?? 0;
    }
  }
  return { pendingCount, estimated, unestimated, byPriority, spent };
}
